import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle, FaEye, FaEyeSlash } from "react-icons/fa";
import { startSession } from "../../session";
import { API_BASE_URL } from "../../config";
import logo from "../../assets/fortunehomecare-logo.png";
import { firstAllowedPath } from "../../components/navigation";

const Login = ({ setLoggedInUser }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const response = await fetch(`${API_BASE_URL}/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), password }),
      });
      const data = await response.json();
      if (response.ok) {
        startSession(data.admin, data.token);
        setLoggedInUser(data.admin);
        navigate(firstAllowedPath(data.admin.permissions || []), { replace: true });
      } else {
        setError(data.error || "Those details did not match an account.");
      }
    } catch {
      setError("Could not reach the server. Check your connection and try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-art">
        <div className="mark">
          <img src={logo} alt="Fortune Home Care" />
        </div>
        <div>
          <h2>Run every cleaning job from one place.</h2>
          <p>Assign vendors, track audits through to completed jobs, and keep the catalogue up to date.</p>
          <ul>
            <li><FaCheckCircle /> Live audit and booking pipeline</li>
            <li><FaCheckCircle /> Vendor and field-staff verification</li>
            <li><FaCheckCircle /> Role-based access for your team</li>
          </ul>
        </div>
        <div className="foot">© {new Date().getFullYear()} Fortune Home Care</div>
      </div>

      <div className="auth-form-side">
        <div className="auth-form">
          <img src={logo} alt="Fortune Home Care" className="mobile-logo" />
          <h1>Sign in</h1>
          <p className="lead">Operations panel for the Fortune Home Care team.</p>

          <form className="form" onSubmit={handleSubmit}>
            {error && <div className="alert alert-error">{error}</div>}
            <div className="field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                className="input"
                type="email"
                autoComplete="username"
                placeholder="you@fortunehomecare.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="field">
              <label htmlFor="password">Password</label>
              <div className="password-field">
                <input
                  id="password"
                  className="input"
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="icon-btn"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
              {busy ? <span className="spinner sm" style={{ borderTopColor: "#fff" }} /> : "Sign in"}
            </button>
          </form>
          <p className="fine">Access is limited to Fortune Home Care staff.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
